import {useApi} from "../Api";
import {UpsellingRateEntityResponse} from "../types/upsellingRate";
import {
    NewUpsellingRateMatrix,
    PostUpsellinRateMatrix,
    UpsellingRateAssociationRequest,
    UpsellingRateAssociationResponse
} from "../types/upsellingRateDetail";

export const useUpsellingRateDetailRepository = () => {
    const {GET, POST, PUT} = useApi();

    const PATH = "/pricing/upselling-rate-detail";

    function postUpsellingRateMatrix(associationRequest: PostUpsellinRateMatrix): Promise<UpsellingRateEntityResponse> {
        return POST(`${PATH}/create-upsell-matrix`, associationRequest);
    }

    function updateUpsellingRateMatrix(associationRequest: UpsellingRateAssociationRequest): Promise<UpsellingRateAssociationResponse> {
        return PUT(`${PATH}/update-price-matrix`, associationRequest);
    }

    function getUpsellingRateMatrix(upsellingRateId: UpsellingRateEntityResponse["id"]): Promise<NewUpsellingRateMatrix> {
        return GET(`${PATH}/get-upsell-matrix?upsellingRateId=${upsellingRateId}`);
    }

    return {
        postUpsellingRateMatrix,
        updateUpsellingRateMatrix,
        getUpsellingRateMatrix
    };
};
